
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseSubNavContainer from '@/containers/base/BaseSubNavContainer.vue'
import BaseListItemContainer from '@/containers/base/BaseListItemContainer.vue'
import {optionsVslim} from '@/config/v-slim-dialog'
import {FaRating} from 'vue-rate-it'
import ThumbsUp from 'vue-rate-it/glyphs/thumbs-up'
import {urlCall3cx, freshdeskBaseUrl} from '@/config/service'

const prospectModule = namespace('prospect')
const formulaireModule = namespace('formulaire')

@Component({
  components: {
    BaseSubNavContainer,
    BaseListItemContainer,
    FaRating
  }
})
export default class ProspectFormulaire extends Vue {
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @formulaireModule.Action('deleteFormulaireAction') deleteFormulaire: any

  async onDelete(id: number) {
    const {ok} = await this.$dialogs.confirm('Confirmez vous la suppression du formulaire ?', optionsVslim)
    if (ok) {
      this.deleteFormulaire(id).then(async () => {
        await this.getProspectById(this.$route.params.id)
      })
    }
  }

  isAds(item) {
    return !!(
      (item.GA_CAMPAIGN && item.GA_CAMPAIGN !== '') ||
      (item.GA_REFERRAL && item.GA_REFERRAL !== '') ||
      (item.GA_KEYWORD && item.GA_KEYWORD !== '') ||
      (item.GA_FINAL_URL && item.GA_FINAL_URL !== '')
    )
  }
}
